// import React, { useState } from "react";
// import { MapPin, Clock, Phone } from "lucide-react";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { motion } from "framer-motion";
import { IoIosCall } from "react-icons/io";
import grievanceData from "../content/grievanceData.json";
// import contactData from "../content/Contact.json";
import PageIntro from "../components/PageIntro";

// const icons = {
//   MapPin,
//   Clock,
//   Phone,
// };

const Contact = () => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   subject: "",
  //   message: "",
  // });

  // const handleChange = (e) =>
  //   setFormData({ ...formData, [e.target.name]: e.target.value });

  // const handleSubmit = () => {
  //   alert("Message sent successfully!");
  //   setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
  // };

  // const { header, contactInfo, footer, formLabels } = contactData;

  const { milestones, stages } = grievanceData;

  const splitTitle = (title, maxWordsPerLine = 4) => {
    const words = title.split(" ");
    if (words.length <= maxWordsPerLine) return [title];
    const mid = Math.ceil(words.length / 2);
    return [words.slice(0, mid).join(" "), words.slice(mid).join(" ")];
  };

  const makeEmailClickable = (text) => {
    return (
      text // Email clickable
        .replace(
          /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g,
          '<a href="mailto:$1" class="text-blue-600 underline font-semibold">$1</a>'
        )
        // Phone clickable (022-62980636 / 1800 209 5600 etc.)
        .replace(
          /(\d{2,4}[-\s]?\d{3,4}[-\s]?\d{3,4})/g,
          (match) =>
            `<a href="tel:${match.replace(
              /[^0-9+]/g,
              ""
            )}" class="text-blue-600 underline font-semibold">${match}</a>`
        )
        .replace(
          /Level 1:/g,
          '<strong class="font-semibold">Level 1 :</strong>'
        )
        .replace(
          /Level 2:/g,
          '<strong class="font-semibold">Level 2 :</strong>'
        )
        .replace(/^Note:/i, '<strong class="font-semibold">Note :</strong>')
    );
  };

  const isMobile = window.innerWidth < 768; // check screen width
  return (
    <>
      <PageIntro
        title="Grievance & Support"
        subtitle="Raise a grievance, request support, or connect with our team for assistance."
      />

      <div className="bg-ofWhite py-10">
        <div className="relative max-w-7xl mx-auto flex items-center justify-center overflow-hidden pb-10">
          {!isMobile ? (
            // ==============================
            // DESKTOP (Horizontal Layout)
            // ==============================
            <svg width="100%" height="360" viewBox="0 0 1200 320">
              {/* Base dashed line */}
              <path
                d="M100 150 L1100 150"
                stroke="#e2deda"
                strokeWidth="1"
                strokeDasharray="6 6"
              />

              {/* Animated gradient line */}
              <motion.path
                d="M100 150 L1100 150"
                stroke="url(#grad)"
                strokeWidth="4"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 5, ease: "easeInOut" }}
              />

              <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="100%" y2="0%">
                  <stop offset="0%" stopColor="#00ffff" />
                  <stop offset="50%" stopColor="#3b82f6" />
                  <stop offset="100%" stopColor="#00ffff" />
                </linearGradient>
              </defs>

              {milestones.map((m, i) => {
                const total = milestones.length - 1;
                const x = 100 + (i * 1000) / total;
                const isTop = i % 2 === 1;
                const delay = (i * 5) / milestones.length;
                const lines = splitTitle(m.title);

                return (
                  <g key={m.id}>
                    <motion.path
                      d={
                        isTop
                          ? `M${x},150 C${x},110 ${x},80 ${x},50`
                          : `M${x},150 C${x},190 ${x},220 ${x},250`
                      }
                      stroke="#e2deda"
                      strokeWidth="1"
                      fill="none"
                      initial={{ pathLength: 0, opacity: 0 }}
                      animate={{ pathLength: 1, opacity: 1 }}
                      transition={{
                        delay: delay + 0.8,
                        duration: 1.2,
                        ease: "easeInOut",
                      }}
                    />

                    <motion.circle
                      cx={x}
                      cy="150"
                      r="6"
                      fill="#cf173c"
                      stroke="#fff"
                      strokeWidth="2"
                      initial={{ scale: 0, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ delay: delay + 0.4, duration: 0.5 }}
                    />

                    <motion.circle
                      cx={x}
                      cy="150"
                      r="4"
                      fill="#cf173c"
                      className="opacity-60"
                      initial={{ scale: 0 }}
                      animate={{ scale: [1, 1.8, 1], opacity: [0.8, 0, 0.8] }}
                      transition={{
                        delay: delay + 0.6,
                        duration: 1.2,
                        repeat: Infinity,
                      }}
                    />

                    <motion.circle
                      cx={x}
                      cy={isTop ? 10 : 250}
                      r="14"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="2"
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ delay: delay + 1 }}
                    />
                    <motion.text
                      x={x}
                      y={isTop ? 15 : 255}
                      textAnchor="middle"
                      className="text-xs font-bold fill-red"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: delay + 1.2 }}
                    >
                      {m.id}
                    </motion.text>

                    {lines.map((line, idx) => (
                      <motion.text
                        key={idx}
                        x={x}
                        y={isTop ? 40 + idx * 18 : 280 + idx * 18}
                        textAnchor="middle"
                        className="text-sm font-medium fill-cyan-300"
                        initial={{ opacity: 0, y: isTop ? -10 : 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          delay: delay + 1.4 + idx * 0.2,
                          duration: 0.6,
                        }}
                      >
                        {line}
                      </motion.text>
                    ))}
                  </g>
                );
              })}
            </svg>
          ) : (
            // ==============================
            // 📱 MOBILE (Vertical Layout)
            // ==============================
            <svg
              width="100%"
              height={milestones.length * 180}
              viewBox="0 0 400 1400"
            >
              {/* Base vertical dashed line */}
              <path
                d={`M200 50 L200 ${milestones.length * 160}`}
                stroke="#e2deda"
                strokeWidth="1"
                strokeDasharray="6 6"
              />

              {/* Animated gradient line */}
              <motion.path
                d={`M200 50 L200 ${milestones.length * 160}`}
                stroke="url(#grad)"
                strokeWidth="4"
                strokeLinecap="round"
                fill="none"
                initial={{ pathLength: 0 }}
                animate={{ pathLength: 1 }}
                transition={{ duration: 5, ease: "easeInOut" }}
              />

              <defs>
                <linearGradient id="grad" x1="0%" y1="0%" x2="0%" y2="100%">
                  <stop offset="0%" stopColor="#00ffff" />
                  <stop offset="50%" stopColor="#3b82f6" />
                  <stop offset="100%" stopColor="#00ffff" />
                </linearGradient>
              </defs>

              {milestones.map((m, i) => {
                const y = 100 + i * 160;
                const delay = (i * 5) / milestones.length;
                const lines = splitTitle(m.title);

                return (
                  <g key={m.id}>
                    <motion.circle
                      cx="200"
                      cy={y}
                      r="6"
                      fill="#cf173c"
                      stroke="#fff"
                      strokeWidth="2"
                      initial={{ scale: 0, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ delay: delay + 0.4, duration: 0.5 }}
                    />
                    <motion.circle
                      cx="200"
                      cy={y}
                      r="4"
                      fill="#cf173c"
                      className="opacity-60"
                      initial={{ scale: 0 }}
                      animate={{ scale: [1, 1.8, 1], opacity: [0.8, 0, 0.8] }}
                      transition={{
                        delay: delay + 0.6,
                        duration: 1.2,
                        repeat: Infinity,
                      }}
                    />
                    <motion.circle
                      cx="200"
                      cy={y - 40}
                      r="14"
                      fill="#fff"
                      stroke="#fff"
                      strokeWidth="2"
                      initial={{ scale: 0 }}
                      animate={{ scale: 1 }}
                      transition={{ delay: delay + 1 }}
                    />
                    <motion.text
                      x="200"
                      y={y - 35}
                      textAnchor="middle"
                      className="text-xs font-bold fill-red"
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      transition={{ delay: delay + 1.2 }}
                    >
                      {m.id}
                    </motion.text>

                    {lines.map((line, idx) => (
                      <motion.text
                        key={idx}
                        x="200"
                        y={y + 30 + idx * 18}
                        textAnchor="middle"
                        className="text-sm font-medium fill-cyan-300"
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{
                          delay: delay + 1.4 + idx * 0.2,
                          duration: 0.6,
                        }}
                      >
                        {line}
                      </motion.text>
                    ))}
                  </g>
                );
              })}
            </svg>
          )}
        </div>
        {stages.map((stage, index) => {
          const phones =
            stage.phones && stage.phones.length
              ? stage.phones
              : stage.phone
              ? [stage.phone]
              : [];

          const emails = stage.email ? [stage.email] : [];

          return (
            <motion.div
              key={index}
              className="max-w-7xl mx-auto bg-white3 p-5 rounded-xl mb-5"
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <h3 className="text-2xl font-medium">{stage.title}</h3>

              {stage.details?.map((text, i) => (
                <p
                  key={i}
                  className="mb-2 mt-2 text-justify text-black"
                  dangerouslySetInnerHTML={{
                    __html: makeEmailClickable(
                      text
                        .replace(/Level 1:/g, "<strong>Level 1:</strong>")
                        .replace(/Level 2:/g, "<strong>Level 2:</strong>")
                    ),
                  }}
                />
              ))}

              {/*  Phones */}
              {phones.map((phone, i) => (
                <p
                  key={i}
                  className="mt-3 flex items-center gap-2 font-semibold"
                >
                  <IoIosCall className="text-red-600 text-lg" />
                  <a
                    href={`tel:${phone.replace(/[^\d+]/g, "")}`}
                    className="underline"
                  >
                    {phone}
                  </a>
                </p>
              ))}

              {/* ✉️ Email */}
              {emails.map((email, i) => (
                <p
                  key={i}
                  className="mt-2 flex items-center gap-2 font-semibold"
                >
                  <MdOutlineMarkEmailRead className="text-red-600 text-lg" />
                  <a href={`mailto:${email}`} className="underline break-all">
                    {email}
                  </a>
                </p>
              ))}
              {stage.note && (
                <div className="mt-4 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded">
                  <p
                    className="text-sm text-gray-800"
                    dangerouslySetInnerHTML={{
                      __html: makeEmailClickable(stage.note),
                    }}
                  />
                </div>
              )}
              {stage.details2 && (
                <p className="mt-3 text-justify">{stage.details2}</p>
              )}
            </motion.div>
          );
        })}
      </div>
      {/* <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-7xl w-full bg-white3 shadow-2xl rounded-lg overflow-hidden relative">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="relative p-8 lg:p-12">
              <div className="mb-12">
                <h1 className="text-3xl lg:text-4xl font-normal text-gray-900 mb-4">
                  {header.heading.split("any Queries or Complaints")[0]}
                  <br />
                  any Queries or Complaints
                </h1>
                <p className="text-gray-500 text-base">{header.subheading}</p>
              </div>

              <div className="space-y-8 mb-16 contact-info-1">
                {contactInfo.map((info, i) => {
                  const Icon = icons[info.icon];
                  return (
                    <div key={i} className="flex gap-4">
                      <div className="flex-shrink-0">
                        <div className="w-16 h-16 rounded-full bg-ofWhite flex items-center justify-center">
                          <Icon className="w-5 h-5 text-gray-700" />
                        </div>
                      </div>
                      <div>
                        <p className="text-gray-500 text-sm mb-1">
                          {info.label}
                        </p>
                        {info.details.map((line, j) => (
                          <p
                            key={j}
                            className="text-gray-900 font-medium text-base text-[22px] leading-[30px]"
                          >
                            {line}
                          </p>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

              <div
                className="absolute bottom-0 left-0 w-[330px] h-[310px] bg-red pointer-events-none"
                style={{ clipPath: "polygon(0 0, 0% 100%, 100% 100%)" }}
              ></div>

              <div className="absolute bottom-12 left-12 z-10 flex items-center gap-2 text-white">
                <ArrowDown className="w-5 h-5" />
                <span className="font-semibold text-lg">
                  {footer.customerCareText}
                </span>
              </div>

              <div className="absolute bottom-12 right-5 z-10 flex gap-4">
                {footer.socials.map((social, i) => {
                  const SocialIcon = icons[social.icon];
                  return (
                    <div
                      key={i}
                      className="w-8 h-8 rounded-full bg-ofWhite backdrop-blur-sm flex items-center justify-center hover:bg-red text-red hover:text-white3 transition-colors cursor-pointer"
                    >
                      <SocialIcon className="w-4 h-4" />
                    </div>
                  );
                })}
              </div>
            </div>

            <div className="bg-ofWhite">
              <div className="space-y-6 contact-form p-8">
                {Object.entries(formLabels).map(([key, label]) => (
                  <div key={key}>
                    <label className="block text-gray-700 text-[18px] leading-[18px] font-normal mb-2">
                      {label}
                    </label>
                    {key === "message" ? (
                      <textarea
                        name={key}
                        value={formData[key]}
                        onChange={handleChange}
                        rows="4"
                        className="w-full px-4 py-3 bg-white3 border border-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent resize-none text-gray-900"
                      ></textarea>
                    ) : (
                      <input
                        type={
                          key === "email"
                            ? "email"
                            : key === "phone"
                            ? "tel"
                            : "text"
                        }
                        name={key}
                        placeholder={label}
                        value={formData[key]}
                        onChange={handleChange}
                        className="w-full px-4 py-3 bg-white3 border border-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent text-gray-900"
                      />
                    )}
                  </div>
                ))}

                <ButtonTwo onClick={handleSubmit} />
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default Contact;
